import API from '@/api'
import CamelCase from './CamelCase'
import Vue from 'vue'

const camelCase = new CamelCase()

export default {
  async authorization({ state, commit }) {
    const formData = new FormData()
    let result = ''

    formData.set('token', state.provider.crm.token.replace('Bearer ', ''))
    formData.set('provider', state.provider.crm.name)

    await API.plChat
      .authorization(formData)
      .then(({ data }) => {
        commit('setCredential', data)
        result = 'ok'

        return data
      })
      .catch(error => {
        result = error
      })

    return result
  },

  async getProfile({ state, commit }) {
    let errorResponseStatus = null
    let responseData = null

    await API.plChat
      .getProfile()
      .then(({ data }) => {
        commit('setProfile', {
          profile: camelCase.keysToCamel(data.data),
        })
        responseData = data
      })
      .catch(error => {
        errorResponseStatus = error?.response?.status || 'Упс! Что-то пошло не так.'
      })

    return errorResponseStatus ? errorResponseStatus : responseData
  },

  async getChatList({ state, commit }, chatPage) {
    await API.plChat
      .getChatList(chatPage)
      .then(response => {
        commit('setLastChatPage', response.data.last_page)
        return camelCase.keysToCamel(response.data.data)
      })
      .then(data => {
        const chatDataWithPinStatus = data.map(chatItem => ({
          ...chatItem,
          isPinned: state.profile.pinnedChatIds.some(id => id === chatItem.id),
          notReadYet: state.profile.unreadChatsIds.some(id => id === chatItem.id),
        }))

        commit('setChatList', {
          chatList: chatDataWithPinStatus,
        })

        return chatDataWithPinStatus
      })
      .then(data => {
        commit('setIdMembersPrivateChats')
      })
  },

  async getUsers({ state, commit }, { reloading, limit, offset }) {
    let url = `${state.provider.chat.url}/users`

    if (reloading) {
      url = `${state.provider.chat.url}/users/?limit=${limit}&offset=${offset}`
    }

    await API.plChat
      .getUsers(url)
      .then(response => {
        return camelCase.keysToCamel(response.data)
      })
      .then(({ data }) => {
        commit('setOffset', data.length)
        commit('setUsers', {
          data,
          search: false,
        })
      })
  },
  async searchUsers({ state, commit }, { searchStr }) {
    await API.plChat
      .searchUsers(searchStr)
      .then(response => {
        return camelCase.keysToCamel(response.data)
      })
      .then(data => {
        commit('setUsers', {
          data: camelCase.keysToCamel(data.data),
          search: true,
        })
      })
  },
  async getMessagesChats({ state, commit }, { chatIds, nextPage }) {
    await chatIds.forEach(chatId => {
      let url = `${state.provider.chat.url}/chat/${chatId}/messages`

      if (nextPage) {
        url = nextPage
      }

      if (chatId !== -1) {
        API.plChat
          .getMessagesChats(url)
          .then(response => {
            return camelCase.keysToCamel(response.data)
          })
          .then(data => {
            commit('setMessagesToChat', {
              chatId: chatId,
              messageArray: data.data,
              nextMessagePage: data.nextPageUrl,
            })

            return data
          })
      }
    })
  },
  async getChatsMembers({ state, commit }, { chatIds }) {
    await chatIds.forEach(chatId => {
      if (chatId !== -1) {
        API.plChat
          .getChatsMembers(chatId)
          .then(({ data: { data } }) => {
            return camelCase.keysToCamel(data)
          })
          .then(data => {
            commit('setMembersToChat', { data, chatId })
          })
      }
    })
  },
  async saveChat({ state }, id) {
    const formData = new FormData()
    const chat = state.chatList.find(chat => chat.id === id)
    let idNewChat

    formData.set('name', chat.name)
    formData.set('_method', 'put')

    // icon в formData только если выбрана новая аватарка через input file
    if (chat.icon && chat.icon instanceof Object) {
      formData.set('icon', chat.icon)
    }

    await API.plChat.saveChat({ formData, id }).then(({ data: { data } }) => {
      idNewChat = data.id
    })

    return idNewChat
  },

  async createChat({ state, getters, commit }, id) {
    const newChat = state.chatList.find(chat => chat.id === id)
    const chatMembers = newChat.users
    const idsMembers = chatMembers.map(member => member.id)
    const formData = new FormData()
    let idNewChat

    if (!newChat.name) {
      formData.set('name', newChat.users[0].name)
    } else {
      formData.set('name', newChat.name)
    }

    formData.set('type', newChat.type)

    if (newChat.type === 'private') {
      formData.set(`users[0]`, idsMembers[0])
    } else if (newChat.type === 'public') {
      idsMembers.forEach((id, key) => {
        formData.set(`users[${key}]`, id)
      })

      if (newChat.icon) {
        formData.set('icon', newChat.icon)
      }
    }

    await API.plChat
      .createChat({ id, formData })
      .then(({ data: { data } }) => {
        return camelCase.keysToCamel(data)
      })
      .then(data => {
        commit('saveChat', data)
        commit('setNewChat', { chatType: newChat.type })
        idNewChat = data.id
      })

    return idNewChat
  },
  getChatData({ state, commit }, id) {
    API.plChat
      .getChatData(id)
      .then(response => {
        return camelCase.keysToCamel(response.data.data)
      })
      .then(data => {
        commit('setActiveChatData', data)
      })
  },
  async getIdsOfAttached(context, attachments) {
    if (!attachments.length) {
      return {}
    }

    const files = []
    const filesIds = []
    const attachedMessagesIds = []

    attachments.forEach(item => {
      if (item.type === 'file') {
        // если файл уже на сервере, то заново грузить не нужно
        if (item.id) {
          filesIds.push(item.id)
        } else {
          files.push(item.fileData)
        }
      } else {
        attachedMessagesIds.push(item.id)
      }
    })

    const promises = files.map(item => {
      const formData = new FormData()
      formData.append('file', item)

      return API.plChat.getAttachedFilesIds(formData).then(({ data: { data } }) => {
        filesIds.push(data.id)
      })
    })

    await Promise.all(promises)

    return { filesIds, attachedMessagesIds }
  },
  async setChatMessage({ state, commit, dispatch }, { chatId, message, attachments = [] }) {
    const { filesIds = [], attachedMessagesIds = [] } = await dispatch('getIdsOfAttached', attachments)

    await API.plChat
      .setChatMessage({
        id: chatId,
        data: {
          text: message,
          files: filesIds,
          attachments: attachedMessagesIds,
        },
      })
      .then(({ data: { data } }) => {
        return camelCase.keysToCamel(data)
      })
      .then(data => {
        commit('addMessageToChat', {
          message: data,
          chatId: chatId,
        })
      })
  },
  deleteMessage({ state, commit }, { id: messageId, chatId }) {
    API.plChat.deleteMessage({ messageId, chatId }).then(() => {
      commit('deleteMessage', { messageId, chatId })
    })
  },
  async updateMessage({ state, commit, dispatch }, { messageId, chatId, messageText, attachments = [] }) {
    const { filesIds = [], attachedMessagesIds = [] } = await dispatch('getIdsOfAttached', attachments)

    API.plChat
      .updateMessage({
        data: {
          text: messageText,
          files: filesIds,
          attachments: attachedMessagesIds,
        },
        messageId,
        chatId,
      })
      .then(({ data: { data } }) => {
        return camelCase.keysToCamel(data)
      })
      .then(data => {
        commit('setEditMessage', {})
        commit('setEditingMessage', data)
      })
  },

  async addMemberToChat({ state }, { chatId, userId }) {
    const formData = new FormData()
    let result = ''

    formData.set('user_id', userId)

    await API.plChat.addMemberToChat({ chatId, formData }).then(({ data }) => {
      result = data.result
      return camelCase.keysToCamel(data.result)
    })

    return result
  },
  async removeMemberToChat({ state, commit }, { chatId, userId }) {
    let result = ''

    await API.plChat.removeMemberFromChat({ chatId, userId }).then(({ data }) => {
      result = data.result
      return camelCase.keysToCamel(data.result)
    })

    return result
  },
}
